exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_swiper__2ZWL_ {\n  background: var(--category-swiper-bg);\n  /* padding: 0 5px 0 0 !important; */\n  --f7-grid-gap: var(--category-swiper-grid-gap);\n}\n\n.styles_swiperSlide__23WyJ {\n  width: var(--category-swiper-item-width) !important;\n  margin-left: var(--f7-grid-gap);\n  /* width: calc((100% - var(--f7-grid-gap) * (var(--f7-cols-per-row) - 1))/ var(--f7-cols-per-row)) !important; */\n}", ""]);

// Exports
exports.locals = {
	"swiper": "styles_swiper__2ZWL_",
	"swiperSlide": "styles_swiperSlide__23WyJ"
};